import { carouselItems } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精选专题</h2>
            <p className="text-sm text-foreground-500 mt-1">六大热门专题，发现你的下一部心头好</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer no-underline"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 bg-background-50/90 text-foreground-800 text-xs font-medium px-2.5 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}